const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

export const checkLink = async (url) => {
  const response = await fetch(`${API_URL}/api/link-check`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ url }),
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível verificar esse link agora.')
  return data
}
